"use strict";

exports.__esModule = true;
exports.default = valueInvoke;

/**
 * Retourne la valeur en paramètre s’il ne s’agit pas d’une fonction.
 * Sinon, le retour de la fonction est renvoyé.
 * @param {any} value Une fonction ou tout autre type. S’il s’agit d’une fonction, son retour sera retourné.
 * @param {Array<any>} attrs Si le paramètre "value" est une fonction, les attributs seront passés à la fonction.
 */
function valueInvoke(value, ...attrs) {
  return "function" === typeof value ? value.apply(undefined, attrs) : value;
}